import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import Head from "../Pages/head";

export default function ProtectedLayout() {
  const token = localStorage.getItem("token");

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return (
    <>
      <Head />
      <Outlet />
    </>
  );
}
